import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify'; // Assuming react-toastify is installed and configured
import { BASE_URL } from '../../api/ApiConfig'; // Assuming BASE_URL is imported similarly to ROOT_URL

export const createKbTag = createAsyncThunk(
  'kbTag/createKbTag',
  async ({ name }, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;
      const business_id = loginToken?.response?.user?.business_id;

      const response = await axios.post(
        `${BASE_URL}/trustchat-backend-service/v1/kb/tag/create`,
        {
          name,
          business_id
        },
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false,
  data: null,
};

const createKbTagSlice = createSlice({
  name: 'createKbTag',
  initialState,
  reducers: {
    resetCreateKbTagState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.data = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createKbTag.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createKbTag.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
        toast.success(action.payload.message || 'Knowledge Base tag created successfully!');
      })
      .addCase(createKbTag.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
        toast.error(action.payload?.message || 'Failed to create tag.');
      });
  }
});

export const { resetCreateKbTagState } = createKbTagSlice.actions;
export default createKbTagSlice.reducer;